import {FC, ReactNode, useEffect} from "react";
import styled, {createGlobalStyle, css} from "styled-components";

const GlobalChangeColorWrapper = createGlobalStyle<any>`
  .app-wrapper {
    transition: background-color 500ms;
    
    ${({bgColor}) => bgColor && css`
      background: ${bgColor} !important;
    `}
  }
`

const BgWrapper = styled.div<any>`
  background: ${p => p?.bgColor ? p?.bgColor : "inherit"};
  transition: background-color 500ms;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`

export const CustomBgWrapper: FC<{isCompetition?: boolean, backgroundColor?: string, children?: ReactNode}> = ({backgroundColor, children, isCompetition}) => {

  useEffect(() => {
    if (backgroundColor && isCompetition) localStorage.setItem('lastCompetitionBG', backgroundColor || '')
  }, [])

    return<BgWrapper className={'BgWrapper-main'} bgColor={backgroundColor? backgroundColor : isCompetition && localStorage.getItem('lastCompetitionBG')? localStorage.getItem('lastCompetitionBG') : ''}>
        <GlobalChangeColorWrapper bgColor={backgroundColor}/>
        {children}
    </BgWrapper>
}import {FC, ReactNode, useEffect} from "react";
import styled, {createGlobalStyle, css} from "styled-components";

const GlobalChangeColorWrapper = createGlobalStyle<any>`
  .app-wrapper {
    transition: background-color 500ms;
    
    ${({bgColor}) => bgColor && css`
      background: ${bgColor} !important;
    `}
  }
`

const BgWrapper = styled.div<any>`
  background: ${p => p?.bgColor ? p?.bgColor : "inherit"};
  transition: background-color 500ms;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`

export const CustomBgWrapper: FC<{isCompetition?: boolean, backgroundColor?: string, children?: ReactNode}> = ({backgroundColor, children, isCompetition}) => {

  useEffect(() => {
    if (backgroundColor && isCompetition) localStorage.setItem('lastCompetitionBG', backgroundColor || '')
  }, [])

    return<BgWrapper className={'BgWrapper-main'} bgColor={backgroundColor? backgroundColor : isCompetition && localStorage.getItem('lastCompetitionBG')? localStorage.getItem('lastCompetitionBG') : ''}>
        <GlobalChangeColorWrapper bgColor={backgroundColor}/>
        {children}
    </BgWrapper>
}